var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.21f67987903b984cd0ecf7543e21160e.svg#h';
                    var viewUrl = 'sprites.21f67987903b984cd0ecf7543e21160e.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };